
import Header from '@/components/jobBooking/Header/Header.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { User } from '@/models/main';
import { formatDateStringWithTZ } from '@/utils/InputProcessingUtilities';
import { notificationErrorText } from '@/utils/PortalConstants';
import { getNewsEntry } from '@/api'; // You'll need to create this API function

interface NewsEntry {
  id: number;
  author: string;
  title: string;
  content: string;
  short_text?: string;
  image?: string;
  type: string;
  content_changes?: string;
  formatted_short_link?: string;
  updated_at: Date;
  created_at: Date;
}

@Component({
  components: {
    Header,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class NewsEntryDetail extends Vue {
  @Prop({ required: false }) private id!: string | number;

  private user!: User;
  private loading = true;
  private entry: NewsEntry = {
    id: 0,
    author: '',
    title: '',
    content: '',
    type: '',
    updated_at: new Date(),
    created_at: new Date(),
  };

  private formatDateStringWithTZ = formatDateStringWithTZ;

  private mounted() {
    const entryId = this.id || this.$route.params.id;
    if (entryId) {
      this.fetchNewsEntry(entryId);
    } else {
      this.loading = false;
      this.$notify({
        group: 'network',
        title: 'Error loading News entry',
        text: 'No news entry ID provided',
        type: 'warn',
      });
    }
  }

  private fetchNewsEntry(id: string | number) {
    this.loading = true;
    getNewsEntry(id)
      .then(response => {
        this.entry = response.data;
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error loading News entry',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
